module.exports = __webpack_public_path__ + "img/ej-gif.76dba428.gif";